/* eslint-disable */

import React, { useEffect, useRef } from 'react';
import { Input, Popconfirm } from 'antd';
import { DeleteOutlined, PlusCircleFilled, SearchOutlined } from '@ant-design/icons';
import { LicenseAccessSelect } from './LicenseAccessSelect';
import { isAssignedProduct } from './licenseFormUtils';

export function LicenseProductAccessSection({
  search,
  searchOpen,
  onSearchChange,
  onSearchOpenChange,
  searchSuggestions,
  categoryNameById,
  productAccess,
  assignedProducts,
  onAddProduct,
  onRemoveProduct,
  onAccessChange,
}) {
  const searchWrapRef = useRef(null);

  useEffect(() => {
    if (!searchOpen) {
      return undefined;
    }

    const handlePointerDown = (event) => {
      if (!searchWrapRef.current?.contains(event.target)) {
        onSearchOpenChange(false);
      }
    };

    document.addEventListener('mousedown', handlePointerDown);
    return () => document.removeEventListener('mousedown', handlePointerDown);
  }, [searchOpen, onSearchOpenChange]);

  return (
    <section className='license-form-section'>
      <div className='license-form-section-heading'>
        <h2 className='license-form-section-title'>กำหนดสิทธิ์ตามรายการสินค้า</h2>
        <p className='license-form-section-caption'>
          กรุณาเลือกสิทธิ์การทำรายการซื้อ-ขาย สำหรับผลิตภัณฑ์แต่ละรายการ (นอกเหนือจากหมวดหมู่)
        </p>
      </div>

      <div className='license-form-search-wrap' ref={searchWrapRef}>
        <Input
          value={search}
          onChange={onSearchChange}
          onFocus={() => {
            if (search.trim()) {
              onSearchOpenChange(true);
            }
          }}
          placeholder='ค้นหาชื่อสินค้า หรือรหัสสินค้า...'
          prefix={<SearchOutlined className='license-form-search-icon' />}
          className='license-form-search'
          allowClear
        />
        {searchOpen ? (
          <div className='license-form-search-dropdown' role='listbox'>
            {searchSuggestions.length === 0 ? (
              <div className='license-form-search-empty'>ไม่พบรายการสินค้า</div>
            ) : (
              searchSuggestions.map((product) => {
                const assigned = isAssignedProduct(productAccess, product.id);
                return (
                  <button
                    key={product.id}
                    type='button'
                    role='option'
                    aria-selected={assigned}
                    className={`license-form-search-option${
                      assigned ? ' license-form-search-option--assigned' : ''
                    }`}
                    onMouseDown={(event) => event.preventDefault()}
                    onClick={() => onAddProduct(product)}
                  >
                    <span className='license-form-search-option-name'>{product.name}</span>
                    <span className='license-form-search-option-category'>
                      {categoryNameById[product.categoryId] || '-'}
                    </span>
                    {assigned ? (
                      <span className='license-form-search-option-added'>มีอยู่ในรายการแล้ว</span>
                    ) : (
                      <PlusCircleFilled className='license-form-search-option-add' />
                    )}
                  </button>
                );
              })
            )}
          </div>
        ) : null}
      </div>

      {assignedProducts.length > 0 ? (
        <div className='license-form-table-wrap license-form-table-wrap--products'>
          <div className='license-form-table-head license-form-table-head--product'>
            <span className='license-form-col-name'>ชื่อสินค้า (PRODUCT NAME)</span>
            <span className='license-form-col-category'>หมวดหมู่สินค้า (PRODUCT CATEGORY)</span>
            <span className='license-form-col-access'>กำหนดสิทธิ์การเข้าถึง</span>
          </div>
          {assignedProducts.map((product, index) => (
            <div
              key={product.id}
              className={`license-form-table-row license-form-table-row--product${
                index % 2 === 0 ? ' license-form-table-row--striped' : ''
              }`}
            >
              <div className='license-form-col-name license-form-product-name'>
                <div className='license-form-product-name-top'>
                  <span className='license-form-product-name-th'>{product.name}</span>
                  <Popconfirm
                    title='ยืนยันการลบ'
                    description='คุณแน่ใจหรือไม่ที่จะลบรายการนี้?'
                    onConfirm={() => onRemoveProduct(product.id)}
                    okText='Yes'
                    cancelText='No'
                  >
                    <button
                      type='button'
                      className='license-form-product-remove'
                      aria-label={`ลบ ${product.name}`}
                    >
                      <DeleteOutlined />
                    </button>
                  </Popconfirm>
                </div>
                {product.inter ? (
                  <span className='license-form-product-name-en'>{product.inter}</span>
                ) : null}
              </div>
              <span className='license-form-col-category'>
                {categoryNameById[product.categoryId] || '-'}
              </span>
              <span className='license-form-col-access'>
                <LicenseAccessSelect
                  value={productAccess[product.id]}
                  onChange={(value) => onAccessChange(product.id, value)}
                />
              </span>
            </div>
          ))}
        </div>
      ) : null}
    </section>
  );
}
